module.exports = __webpack_public_path__ + "static/media/pagenotfound.fca2f306.gif";